export default "__VITE_ASSET__DrmlUjrF__"